// Español — España / México
export default {
  translation: {
    app_name: 'Agora',
    tagline: 'Donde los hobbies construyen comunidades',
    nav_explore: 'Explorar',
    nav_find_folks: 'Encontrar gente',
    nav_sign_in: 'Iniciar sesión',
    nav_join_free: 'Únete gratis',
    nav_sign_out: 'Cerrar sesión',
    nav_my_profile: 'Mi perfil',
    nav_notifications: 'Notificaciones',
    auth_register: 'Crear cuenta',
    auth_login: 'Iniciar sesión',
    auth_name: 'Nombre completo',
    auth_email: 'Correo electrónico',
    auth_password: 'Contraseña',
    auth_age: 'Tu edad',
    auth_city: 'Ciudad',
    auth_building: 'Edificio / Urbanización',
    auth_country: 'País',
    auth_currency: 'Moneda',
    auth_locale: 'Idioma y región',
    auth_already_have_account: '¿Ya tienes cuenta?',
    auth_no_account: '¿No tienes cuenta?',
    postcode_label: 'Código postal',
    postcode_placeholder: 'p.ej. 28001',
    profile_edit: 'Editar perfil',
    profile_bio: 'Biografía',
    profile_interests: 'Intereses',
    profile_location: 'Ubicación',
    profile_theme: 'Tema',
    profile_currency_settings: 'Moneda y región',
    profile_save: 'Guardar cambios',
    profile_cancel: 'Cancelar',
    group_join: 'Unirse al grupo',
    group_leave: 'Abandonar grupo',
    group_members: 'Miembros',
    group_chat: 'Chat',
    group_events: 'Eventos',
    group_shop: 'Tienda',
    group_campaigns: 'Campañas',
    group_about: 'Acerca de',
    group_full: 'Completo',
    group_open: 'Abierto',
    tip_send: 'Enviar propina',
    tip_amount: 'Cantidad',
    tip_message: 'Mensaje (opcional)',
    wallet_coins: 'monedas',
    wallet_balance: 'Saldo',
    tips_earned: 'ganados',
    event_register: 'Registrarse',
    event_unregister: 'Cancelar registro',
    event_ticket_price: 'Entrada',
    event_free: 'Gratis',
    event_capacity: 'Capacidad',
    event_registered: 'registrado(s)',
    no_results: 'Sin resultados',
    loading: 'Cargando…',
    error_generic: 'Algo salió mal. Por favor intenta de nuevo.',
  }
};
